import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  Target,
  VerificationService,
} from '../../services/verification/verification.service';
import { StepDelegate } from '../../models/intefaces/step-delegate';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AcceptationFormComponent } from './acceptation-form/acceptation-form.component';
import { catchError, map } from 'rxjs/operators';
import { FormStep } from '../../models/steps/form-step';
import { OrderingProcessService } from '../../services/ordering-process/ordering-process.service';
import { LoginInformation } from '../../models/intefaces/login-information';
import { OrderService } from '../../services/order/order.service';
import { ValidationRequest } from '../../models/intefaces/validation-request';
import { MatDialog } from '@angular/material/dialog';
import { RequestErrorComponent } from './request-error/request-error.component';
import { TranslationsService } from '../../services/translations/translations.service';
import { CongratulationsRouteName } from '../../models/constants';
import { UserService } from '../../services/user/user.service';

const empty: LoginInformation = {
  confirmPassword: '',
  password: '',
};

@Component({
  selector: 'app-summarize',
  templateUrl: './summarize.component.html',
  styleUrls: ['./summarize.component.scss'],
})
export class SummarizeComponent implements OnInit, StepDelegate, AfterViewInit {
  @ViewChild(AcceptationFormComponent)
  acceptationForm?: AcceptationFormComponent;

  language = '';
  loading = false;

  private readonly isReady = new BehaviorSubject(false);

  get ready(): Observable<boolean> {
    return this.isReady.asObservable();
  }

  constructor(
    private readonly httpClient: HttpClient,
    private readonly verificationService: VerificationService,
    private readonly orderService: OrderService,
    private readonly matDialog: MatDialog,
    private readonly translationsService: TranslationsService,
    private readonly router: Router,
    private readonly orderingProcessService: OrderingProcessService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    this.language = this.translationsService.getCurrentLanguage();
  }

  ngAfterViewInit(): void {
    const step: FormStep = this.orderingProcessService.getCurrentStep();
    step.setDelegate(this);
  }

  onSubmit(): Observable<boolean> {
    return this.getReady() ? this.send() : of(false);
  }

  private getReady(): boolean {
    let ready = false;
    this.ready.subscribe((isReady) => (ready = isReady)).unsubscribe();
    return ready;
  }

  private send(): Observable<boolean> {
    const loginInformation = this.export();
    if (loginInformation !== empty) {
      loginInformation.lang = this.language;
      this.verificationService.setAccount(loginInformation);
      return this.sendRequest();
    }
    return of(false);
  }

  private sendRequest(): Observable<boolean> {
    const linkToAccount: boolean = this.getLinkToAccount();
    this.setLoading(true);

    return this.verificationService
      .send<ValidationRequest>(Target.web, linkToAccount)
      .pipe(
        map((result: ValidationRequest) => {
          this.setLoading(false);
          if (result.success) {
            this.orderService.reset();
            this.verificationService.reset();
            this.userService.setUser(result.user);
            this.router.navigate([this.language, CongratulationsRouteName]);
            return false;
          } else if (result.error) {
            this.matDialog.open(RequestErrorComponent, { data: result.error });
          }
          return false;
        })
      )
      .pipe(
        catchError((error) => {
          this.setLoading(false);
          return Observable.throw(error.message || 'server error.');
        })
      );
  }

  private getLinkToAccount(): boolean {
    return (
      (this.translationsService.getTranslations().authenticated &&
        this.acceptationForm?.accountInformation?.control.value) ||
      false
    );
  }

  private export(): LoginInformation {
    return (
      (this.acceptationForm &&
        this.acceptationForm.accountInformation?.export()) ||
      empty
    );
  }

  private setLoading(state: boolean) {
    const loaderContainer = document.querySelector('.loader-container-kala');
    if (state) {
      this.loading = true;
      return loaderContainer?.classList.add('showContainer');
    }
    this.loading = false;
    return loaderContainer?.classList.remove('showContainer');
  }

  onReady(isReady: boolean): void {
    this.isReady.next(isReady);
  }
}
